import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiDropdown from "../../Components/DropDown/Apidropdown";
import Input from "../../Components/input/input";
import config from "../../config";
import "../../Style/IncidentAdd.css";
import { useFetchFullName } from "../Incidents/Hooks/useFetchFullName";
import { Task, initialTask } from "./Task";
import { TaskData } from "../../utils/Task/taskTypes";
import { ChangeData } from "../../utils/Change/changeTypes";
import { KnowledgeBaseData } from "../../utils/KnowledgeBase/KnowledgeBaseTypes";
import { RmaData } from "../../utils/Rma/rmaTypes";
import { Incident, initialIncident } from "../Incidents/Incident";
import TaskGridLookup from "../../Components/Lookup/Lookup";
import { IncidentData } from "../../utils/Incident/incidentTypes";
import TaskGridLookupModal, {
  toRelatedItems,
} from "../../Components/Lookup/IncidentLookUp";
import Checkbox from "../../Components/checkbox/Checkbox";
import TextArea from "../../Components/TextArea/TextArea";
import FileUploader from "../../Components/FileUpload/FileUpload";
import { authFetch } from "../../utils/Security/authFetch";
import { handleEdit } from "../../utils/Task/taskHandlers";
import { ProblemData } from "../../utils/Problem/problemTypes";
import { joinMulti, splitMulti } from "../../utils/multiValue";
type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
function TaskEdit() {
  const [task, setTask] = useState<Task>(initialTask);
  const { id } = useParams();
  const [emails, setEmails] = useState<[]>();
  const [network, setNetwork] = useState<
    string | number | (string | number)[] | null
  >(null);
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);

  const [site, setSite] = useState<
    string | number | (string | number)[] | null
  >(null);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const isForTelebras = localStorage.getItem("isForTelebras") === "true";
  const isForPetrobras = localStorage.getItem("isForPetrobras") === "true";
  const handleTaskSelect = (
    tasks: (
      | IncidentData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | TaskData
    )[],
  ) => {
    const ticketIds = tasks.map((t) => t.ticketId); // collect all selected ticketIds
    handleDataChange("relatedobject", ticketIds); // now this should be an array
    setSelectedTask(tasks); // you might rename this to selectedTasks now
  };

  const [isTaskLookupOpen, setIsTaskLookupOpen] = useState(false);
  const handleOpenTaskLookup = () => setIsTaskLookupOpen(true);
  const handleCloseTaskLookup = () => setIsTaskLookupOpen(false);
  const [selectedTask, setSelectedTask] = useState<
    (
      | IncidentData
      | ChangeData
      | RmaData
      | KnowledgeBaseData
      | ProblemData
      | TaskData
    )[]
  >([]);
  const [customer, setCustomer] = useState<
    string | number | (string | number)[] | undefined
  >(undefined);
  useEffect(() => {
    setCustomer(task.affectedCustomer || []);
  }, [task.affectedCustomer]);
  const navigate = useNavigate();
  const organization = localStorage.getItem("organization") || undefined;
  useEffect(() => {
    if (id) {
      authFetch(`${config.apiBaseUrl}/api/tasks/${id}`)
        .then((res) => res.json())
        .then((data) => setTask(data))
        .catch((err) => console.error("Failed to fetch task:", err));
    }
  }, [id]);

  function formatDateTimeLocal(datetime: string): string {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }
  useFetchFullName((fullName: string) => {
    setTask((prev: any) => ({ ...prev, user: fullName }));
  });

  const handleDataChange = (field: keyof Task, value: any) => {
    setTask((prev: any) => ({ ...prev, [field]: value }));
  };
  //console.log("sdsfdsfsdfsdfsdfsfd", task);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const updatedTask: Task = {
      ...task,
      affectedSite:
        localStorage.getItem("isAllSite") === "true"
          ? ["All Sites"]
          : task.affectedSite,
      affectedLink:
        localStorage.getItem("isAllLink") === "true"
          ? ["All Links"]
          : task.affectedLink,
      affectedNetwork:
        localStorage.getItem("isAllNetwork") === "true"
          ? ["All Networks"]
          : task.affectedNetwork,
    };
    authFetch(`${config.apiBaseUrl}/api/tasks/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updatedTask),
    })
      .then((res) => res.json())
      .then(async (data) => {
        const fetchMessages = async () => {
          if (!data?.ticketId) return;
          const res = await authFetch(
            `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`,
          );
          if (res.ok) setJournalMessages(await res.json());
        };
        await handleEdit(data, navigate, fetchMessages);
        navigate("/task");
      })
      .catch((err) => console.error("Failed to update task:", err));
  };
  const formatDate = (dateStr: string): string => {
    if (!dateStr) return "";
    return dateStr.replace("T", " ").split(".")[0];
  };

  const handleCancel = () => {
    navigate("/task");
  };
  return (
    <div className="incident-form">
      <form onSubmit={handleSubmit}>
        <section className="form-section">
          <h3>Task Information</h3>
          <div className="grid">
            <Input
              type="text"
              label="Created By"
              value={task.createdby ?? ""}
              onChange={(val) => handleDataChange("createdby", val)}
              readOnly
            />
            <ApiDropdown
              api="users"
              labelKey="username"
              valueKey="id"
              label="User"
              value={task.userid || ""}
              onChange={async (val) => {
                handleDataChange("userid", val);
                if (val != null) {
                  try {
                    const res = await authFetch(
                      `${config.apiBaseUrl}/api/users/${val}`,
                    );
                    if (!res.ok) throw new Error("User not found");
                    const user = await res.json();
                    handleDataChange("email", user.email);
                  } catch (err) {
                    console.error("Error fetching user:", err);
                  }
                }
              }}
            />
            <Input
              type="text"
              label="Ticket Id"
              value={task.ticketId || ""}
              onChange={(val) => handleDataChange("ticketId", val)}
            />
            <Input
              type="text"
              label="Status"
              value={task.status || ""}
              onChange={(val) => handleDataChange("status", val)}
            />
            <Input
              type="datetime-local"
              label="Ticket Creation Date/Time (UTC)"
              value={task.ticketCreationDatetime}
              onChange={(val) =>
                handleDataChange("ticketCreationDatetime", val)
              }
            />
            <Input
              type="datetime-local"
              label="Ticket Closure Date/Time (UTC)"
              value={task.ticketClosureDatetime || ""}
              onChange={(val) => handleDataChange("ticketClosureDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Planned Start Date/Time (UTC)"
              value={task.taskStartDatetime || ""}
              onChange={(val) => handleDataChange("taskStartDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Planned End Date/Time (UTC)"
              value={task.taskCloseDatetime || ""}
              onChange={(val) => handleDataChange("taskCloseDatetime", val)}
            />
            <Input
              type="datetime-local"
              label="Impact Start Date/Time (UTC)"
              value={task.imapcttaskStartDatetime || ""}
              onChange={(val) =>
                handleDataChange("imapcttaskStartDatetime", val)
              }
            />
            <Input
              type="datetime-local"
              label="Impact End Date/Time (UTC)"
              value={task.impacttaskCloseDatetime || ""}
              onChange={(val) =>
                handleDataChange("impacttaskCloseDatetime", val)
              }
            />
            <Input
              type="datetime-local"
              label="Impact Preiod"
              readOnly
              value={task.taskResolutionTime || ""}
              onChange={(val) => handleDataChange("taskResolutionTime", val)}
            />

            <Checkbox
              label="Customer Approval"
              onChange={(e) =>
                handleDataChange("customerapproval", e.target.checked)
              }
              checked={task.customerapproval}
            />
          </div>
        </section>

        <section className="form-section">
          <h3>Customer & Network</h3>
          <div className="grid">
            {/* <ApiDropdown
              api="affected-customers"
              labelKey="customername"
              valueKey="customername"
              label="Affected customer"
              value={incident.affectedCustomer}
              onChange={(val) => handleDataChange("affectedCustomer", val)}
            /> */}
            {!isAdmin && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                value={organization}
                valueKey="customername"
                label="Customer"
                disabled
                isMulti
                onOpen={async () => {
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${organization}`,
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`,
                      );
                    const userIds = await responseIds.json();
                    //console.log("Fetched user IDs:", userIds);

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`,
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    //console.log("Fetched emails:", emails);

                    handleDataChange("foruserid", userIds);

                    handleDataChange("affectedCustomer", [organization]);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {isAdmin && !isForTelebras && !isForPetrobras && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                valueKey="customername"
                label="Customer"
                value={customer}
                isMulti
                onChange={async (val) => {
                  setCustomer(val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`,
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`,
                      );
                    const userIds = await responseIds.json();
                    //console.log("Fetched user IDs:", userIds);

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`,
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);
                    //console.log("Fetched emails:", emails);

                    handleDataChange("foruserid", userIds);
                    handleDataChange("affectedCustomer", val);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {isAdmin && isForPetrobras && (
              <ApiDropdown
                api="affected-customers"
                labelKey="customername"
                valueKey="customername"
                label="Customer"
                value={customer}
                isMulti
                disabled
                onChange={async (val) => {
                  setCustomer(val);
                  try {
                    const responseIds = await authFetch(
                      `${config.apiBaseUrl}/api/users/id-by-organization?organization=${val}`,
                    );
                    if (!responseIds.ok)
                      throw new Error(
                        `HTTP error! status: ${responseIds.status}`,
                      );
                    const userIds = await responseIds.json();

                    const userIdsParam = Array.isArray(userIds)
                      ? userIds.join(",")
                      : userIds;
                    const responseEmails = await authFetch(
                      `${config.apiBaseUrl}/api/users/email-by-id?id=${userIdsParam}`,
                    );
                    if (!responseEmails.ok)
                      throw new Error(
                        `HTTP error! status: ${responseEmails.status}`,
                      );
                    const emails = await responseEmails.json();
                    setEmails(emails);

                    handleDataChange("foruserid", userIds);
                    handleDataChange("affectedCustomer", val);
                  } catch (error) {
                    console.error("Failed to fetch customer or emails:", error);
                  }
                }}
              />
            )}
            {!isAdmin && organization && (
              <ApiDropdown
                api={`everything/networks?customer=${organization}`}
                labelKey="label"
                valueKey="value"
                label="Networks"
                value={task.affectedNetwork}
                isMulti
                onChange={(val) => {
                  setNetwork(val);
                  handleDataChange("affectedNetwork", val);
                }}
              />
            )}

            {!isAdmin && organization && (
              <>
                {(network || task.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${organization}&network=${
                      network || task.affectedNetwork
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Site"
                    value={task.affectedSite}
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}

                {(site || task.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${organization}&network=${
                      network || task.affectedNetwork
                    }&site=${site || task.affectedSite}`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={task.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}

                <ApiDropdown
                  api={`everything/asset?customer=${organization}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
                  isMulti
                  value={splitMulti(task.asset)}
                  onChange={(val) =>
                    handleDataChange("asset", joinMulti(val))
                  }
                />
              </>
            )}

            {isAdmin && (
              <>
                {(customer || task.affectedCustomer) && (
                  <ApiDropdown
                    api={`everything/networks?customer=${
                      customer || task.affectedCustomer
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Networks"
                    value={task.affectedNetwork}
                    isMulti
                    onChange={(val) => {
                      setNetwork(val);
                      handleDataChange("affectedNetwork", val);
                    }}
                  />
                )}

                {(network || task.affectedNetwork) && (
                  <ApiDropdown
                    api={`everything/sites?customer=${
                      customer || task.affectedCustomer
                    }&network=${network || task.affectedNetwork}`}
                    labelKey="label"
                    valueKey="value"
                    value={task.affectedSite}
                    label="Site"
                    isMulti
                    onChange={(val) => {
                      setSite(val);
                      handleDataChange("affectedSite", val);
                    }}
                  />
                )}

                {(site || task.affectedSite) && (
                  <ApiDropdown
                    api={`everything/links?customer=${
                      customer || task.affectedCustomer
                    }&network=${network || task.affectedNetwork}&site=${
                      site || task.affectedSite
                    }`}
                    labelKey="label"
                    valueKey="value"
                    label="Link"
                    value={task.affectedLink}
                    isMulti
                    onChange={(val) => handleDataChange("affectedLink", val)}
                  />
                )}

                <ApiDropdown
                  api={`everything/asset?customer=${customer}&network=${network}`}
                  labelKey="label"
                  valueKey="value"
                  label="Assets"
                  isMulti
                  value={splitMulti(task.asset)}
                  onChange={(val) =>
                    handleDataChange("asset", joinMulti(val))
                  }
                />
                <ApiDropdown
                  api={`everything/antenna?customer=${customer}`}
                  labelKey="label"
                  valueKey="value"
                  label="Antennas"
                  isMulti
                  value={splitMulti(task.affectedAntenna)}
                  onChange={(val) =>
                    handleDataChange("affectedAntenna", joinMulti(val))
                  }
                />
              </>
            )}
          </div>
        </section>

        <section className="form-section">
          <h3>Task severity</h3>
          <div className="grid">
            <ApiDropdown
              api="Urgencys"
              labelKey="name"
              valueKey="name"
              label="Priority"
              value={task.priority}
              onChange={(val) => handleDataChange("priority", val)}
            />
          </div>
        </section>

        <section className="form-section">
          <h3>Task details</h3>
          <div className="grid2">
            <TextArea
              label="Summary"
              required={true}
              style={{
                minHeight: "30px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              value={task.summary}
              onChange={(val: any) => handleDataChange("summary", val)}
            />
            <TextArea
              label="Description"
              required={true}
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              value={task.description}
              onChange={(val: any) => handleDataChange("description", val)}
            />
            <TextArea
              label="Solution"
              value={task.solution}
              style={{
                minHeight: "100px",
                minWidth: "90%",
                backgroundColor: "white",
              }}
              onChange={(val) => handleDataChange("solution", val)}
            />
            <ApiDropdown
              api="Tasktypes"
              value={task.tasktype}
              labelKey="name"
              valueKey="name"
              required
              label="Type of task"
              onChange={(val) => handleDataChange("tasktype", val)}
            />
            <ApiDropdown
              api="ClosureCodesTask"
              labelKey="name"
              valueKey="name"
              label="Closure Code"
              onChange={(val) => handleDataChange("closureCode", val)}
            />
          </div>
        </section>

        <section className="form-section">
          <h3>Responsibility</h3>
          <div className="grid">
            {/* <ApiDropdown
              api="Team"
              labelKey="name"
              valueKey="id"
              label="Responsible Team"
              value={task.teamId}
              onChange={(val) => handleDataChange("teamId", val)}
            />
            <ApiDropdown
              api="Person"
              labelKey="name"
              valueKey="id"
              label="Responsible Person"
              value={task.personId}
              onChange={(val) => handleDataChange("personId", val)}
            /> */}
            <Input
              readOnly
              type="text"
              label="Responsible Team"
              value={task.responsibleTeam || ""}
              onChange={() => {}}
            />
            <Input
              readOnly
              type="text"
              label="Responsible Person"
              value={task.responsiblePerson || ""}
              onChange={() => {}}
            />
          </div>
        </section>

        <section className="form-section">
          <h3> OLA</h3>
          <div className="grid">
            <Input
              readOnly
              type="text"
              label="Reaction Point"
              value={task.reactionPoint ? formatDate(task.reactionPoint) : ""}
              onChange={(val) => handleDataChange("reactionPoint", val)}
            />
            <Input
              type="datetime-local"
              label="Acceptance Time"
              readOnly
              value={
                task.acceptanceTime
                  ? formatDateTimeLocal(task.acceptanceTime)
                  : ""
              }
              onChange={(val) => handleDataChange("acceptanceTime", val)}
            />
            <Input
              type="text"
              label="Acceptance Status"
              readOnly
              value={task.acceptanceStatus || ""}
              onChange={(val) => handleDataChange("acceptanceStatus", val)}
            />
          </div>
        </section>
        {isAdmin && (
          <section className="form-section">
            <h3>Related Object</h3>
            <div className="grid">
              <FileUploader
                value={task.filePath}
                onRemove={(path) =>
                  handleDataChange("filePath", (task.filePath || []).filter((p: any) => p !== path))
                }
                onChange={async (files, paths) => {
                  if (!files || !paths.length) return;
                  const uploadedPaths: string[] = [];
                  for (let i = 0; i < files.length; i++) {
                    const formData = new FormData();
                    formData.append("file", files[i]);
                    try {
                      const response = await authFetch(
                        `${config.apiBaseUrl}/api/tasks/upload`,
                        {
                          method: "POST",
                          body: formData,
                        },
                      );
                      if (response.ok) {
                        const { path } = await response.json();
                        uploadedPaths.push(path);
                      } else {
                        console.error(
                          `Upload failed for file: ${files[i].name}`,
                        );
                      }
                    } catch (error) {
                      console.error("Error uploading file", error);
                    }
                  }
                  if (uploadedPaths.length) {
                    handleDataChange("filePath", [
                      ...(task.filePath || []),
                      ...uploadedPaths,
                    ]);
                  }
                }}
              />
              <Input
                readOnly
                type="text"
                label="Related Object"
                value={task.relatedobject || ""}
                onChange={(val) => handleDataChange("relatedobject", val)}
              />

              {isAdmin && (
                <>
                  {!isForTelebras && (
                    <button type="button" onClick={handleOpenTaskLookup}>
                      Select Related Ticket
                    </button>
                  )}
   {toRelatedItems(task.relatedobject).length > 0 && (
                    <div>
                      <p>
                        <strong>Selected Tasks:</strong>
                      </p>
                      <ul>
                        {toRelatedItems(task.relatedobject).map((task, index) => (
                          <li key={index}>{task.ticketId}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <TaskGridLookupModal
                    isOpen={isTaskLookupOpen}
                    onClose={handleCloseTaskLookup}
                    onSelect={handleTaskSelect}
                    selectedItems={toRelatedItems(task.relatedobject)}
                  />
                </>
              )}
            </div>
          </section>
        )}
        <button onClick={handleSubmit}>Submit Task</button>
        <button type="button" onClick={handleCancel}>
          Cancel
        </button>
      </form>
    </div>
  );
}

export default TaskEdit;
